<div class="chart-wrap">
    <canvas
        baseChart
        [data]="doughnutChartData"
        [labels]="doughnutChartLabels"
        [colors]="doughnutChartColors"
        [chartType]="doughnutChartType"
    >
    </canvas>
</div>
